<script setup>
import MainButton from "@/components/helpers/MainButton.vue";
import AgencyFeesProgressBar from "@/components/dashboard/AgencyFeesProgressBar.vue";
import { ref } from "vue";
import SubscriptionsModal from "@/modules/agency-fees/components/SubscriptionsModal.vue";

defineProps({
  agentSubscriptions: {
    type: Array,
    default: () => [],
  },
});

const isShowModal = ref(false);
</script>

<template>
  <section class="agency-fees">
    <header class="agency-fees__header">
      <div class="agency-fees__header-title">
        <h4>Агентские вознаграждения</h4>

        <VPopover>
          <span class="icon-info" />

          <div slot="popover" class="agency-fees__tooltip-container">
            <p>
              При выборе способа оплаты «При получении» через кнопку
              «Забронировать» заказ не будет учитываться в обороте
            </p>
          </div>
        </VPopover>
      </div>
      <p>
        Активируйте план агентских вознаграждений, оплачивая покупки онлайн в RC
        PAY

        <a href="https://esd.docs-lab.ru/document/download/167" download>
          Инструкция
        </a>
      </p>
    </header>
    <div class="agency-fees__progress">
      <h5>Прогресс:</h5>
      <AgencyFeesProgressBar :progress-elements="agentSubscriptions" />
    </div>
    <MainButton
      title="За покупками"
      color="gold"
      href="https://rcpay.ru/"
      target="_blank"
    />

    <SubscriptionsModal
      :is-show-modal="isShowModal"
      @close="isShowModal = false"
    />
  </section>
</template>

<style lang="scss">
.agency-fees {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 32px;
  border-radius: 16px;
  background: var(--background-light-second, #f8f8f8);

  @media (max-width: 1023px) {
    gap: 16px;
    padding: 24px;
  }

  &__header {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    &-title {
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: space-between;

      > h4 {
        color: var(--text-dark-primary, #212121);
        @include body-1-bold;
      }

      .icon-info {
        width: 20px;
        height: 20px;
        background-color: #212121;
      }
    }

    > p {
      color: var(--text-dark-second, #2f2f2f);
      @include body-1;
      display: flex;
      flex-direction: column;
      gap: 4px;

      > a {
        color: var(--other-link-blue, #2f80ed);
      }
    }
  }

  &__tooltip-container {
    > p {
      color: #212121;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 140%;
      font-feature-settings: "pnum" on, "lnum" on;
    }
  }

  &__progress {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    > h5 {
      color: var(--consistent-dark-primary, #212121);
      @include text-2-bold;
    }
  }
}

.icon-info {
  cursor: pointer;
}

.tooltip-inner {
  padding: 20px !important;
}
</style>
